module.exports = __webpack_public_path__ + "img/274001489.ceb3052a.jpg";